export const VALUES_FIELD_CONTENT = [
    'f3a5',
    'f192',
    'f111',
    'f111',
    'f0fe',
    'f182',
    'f183',
    'f0f4',
    'f2e7',
    'f015',
    'f193',
] as const;
export type TYPES_FIELD_CONTENT = typeof VALUES_FIELD_CONTENT[number];

export const VALUES_FIELD_ICON = [
    'far fa-gem',
    'far fa-dot-circle',
    'fas fa-circle',
    'far fa-circle',
    'fas fa-plus-square',
    'fas fa-female',
    'fas fa-male',
    'fas fa-coffee',
    'fas fa-utensils',
    'fas fa-home',
    'fas fa-wheelchair',
] as const;
export type TYPES_FIELD_ICON = typeof VALUES_FIELD_ICON[number];

export const VALUES_FIELD_TEXT = [
    '[[f219]]',
    'Dot circle',
    '[[f111]]',
    'Circle',
    '[[f0fe]]',
    'Female',
    'Male',
    'Coffee',
    'Cutlery',
    '[[f015]]',
    '[[f193]]',
] as const;
export type TYPES_FIELD_TEXT = typeof VALUES_FIELD_TEXT[number];
